import Vue from 'vue';
import Vuetify from 'vuetify';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import loading from './app/loading';
import * as VueGoogleMaps from 'vue2-google-maps';
import PortalVue from 'portal-vue';
import bindingConv from '@/library/BindingConverters';
import imageConv from '@/library/ImageConverter';
import VueApexCharts from 'vue-apexcharts';
import VueGeolocation from 'vue-browser-geolocation';



// -- Sentry imtegration -------------------------------------------------
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

// Set user information, as well as tags and further extras
// Sentry.configureScope(scope => {
//   scope.setExtra('battery', 0.7);
//   scope.setTag('user_mode', 'admin');
//   scope.setUser({ id: '4711' });
//   // scope.clear();
// });
if (process.env.VUE_APP_ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: 'https://da1b4b8c19b34907a209bebf98fbfe2b@sentry.io/1412424',
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
    release: process.env.VUE_APP_VERSION,
  });

  Sentry.configureScope((scope) => {
    scope.addEventProcessor((event) => {
      Object.assign(event, { user: store.getters.currentUser });
      return event;
    });
  });
}
// -----------------------------------------------------------------------

import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.use(PortalVue);
Vue.use(VueApexCharts);
Vue.use(VueGeolocation);

Vue.config.productionTip = false;

store.commit('initialise');

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDq88QkcgATP_sxy3I4KotzWNLR49ZmbGM',
    libraries: 'places,drawing,visualization',
  },
  installComponents: true,
});


Vue.use(PortalVue);

Vue.prototype.$loading = loading;
Vue.prototype.$bc = bindingConv;
Vue.prototype.$ic = imageConv;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
